import { put, call, select } from 'redux-saga/effects'
import { transactionsApiService, handleError } from 'Services/ApiService.js'
import transactionActions from 'Stores/Transaction/Actions'
import history from 'history/browser'
import {
  encodeObjectToBase64,
  decodeBase64ToObject,
} from '../Utils/Base64Functions'
import { INITIAL_STATE } from 'Stores/Transaction/initialState'
import AuthSelectors from 'Stores/Auth/Selectors'
import IFFilterType from 'Enums/IFFilterType'
import InfinityEnums from 'Enums/InfinityEnums'

export function* fetchTransactionsList({ filter, offset, shouldShowError }) {
  const query = new URLSearchParams(history.location.search)
  let filterParam = query.get('filter')
  let filterObject = []
  let defaultTransactionFilters = INITIAL_STATE.transactionsFilter
  try {
    const admin = yield select(AuthSelectors.getUser)
    if (admin.registeredCountries.length > 1) {
      const countryNames = admin.registeredCountries.map(
        (country) => country.name,
      )
      let initialCountry = admin.registeredCountries[0].name
      let index = defaultTransactionFilters.findIndex(
        (filter) => filter.type === IFFilterType.SELECT,
      )
      if (index === -1)
        defaultTransactionFilters.push({
          type: IFFilterType.SELECT,
          title: InfinityEnums.IFFilterTitle.Country,
          data: countryNames,
          initialValue: initialCountry,
          value: initialCountry,
          canClear: false,
          field: 'Country',
        })
    }
    if (filterParam === null) {
      filterObject = defaultTransactionFilters
      filterParam = encodeObjectToBase64(filterObject)
    } else {
      try {
        filterObject = decodeBase64ToObject(filterParam)
        if (admin.registeredCountries.length > 1) {
          const countryNames = admin.registeredCountries.map(
            (country) => country.name,
          )
          let initialCountry = admin.registeredCountries[0].name
          let index = filterObject.findIndex(
            (filter) => filter.type === IFFilterType.SELECT,
          )
          if (index === -1)
            filterObject.push({
              type: IFFilterType.SELECT,
              title: InfinityEnums.IFFilterTitle.Country,
              data: countryNames,
              initialValue: initialCountry,
              value: initialCountry,
              canClear: false,
              field: 'Country',
            })
        }
        for (let i = 0; i < filterObject.length; i++) {
          const { type: type1, title: title1, data: data1 } = filterObject[i]
          const {
            type: type2,
            title: title2,
            data: data2,
          } = defaultTransactionFilters[i]
          if (
            type1 !== type2 ||
            title1 !== title2 ||
            JSON.stringify(data1) !== JSON.stringify(data2)
          ) {
            filterObject = defaultTransactionFilters
            filterParam = encodeObjectToBase64(filterObject)
          }
        }
      } catch (error) {
        filterObject = defaultTransactionFilters
        filterParam = encodeObjectToBase64(filterObject)
      }
    }
    if (offset === 0) {
      yield put(transactionActions.fetchTransactionsListLoading())
    }
    const { data } = yield call(transactionsApiService.get, '/', {
      params: {
        filter: filterParam,
        offset: offset,
      },
    })
    yield put(
      transactionActions.fetchTransactionsListSuccess(
        offset,
        data.transactions,
        data.nextOffset,
        filterObject,
      ),
    )
  } catch (e) {
    yield put(transactionActions.fetchTransactionsListError(e))
    if (!shouldShowError) handleError(e)
  }
}

export function* fetchTransactionsMetrics({ filter, offset }) {
  yield put(transactionActions.fetchTransactionsMetricsLoading())
  try {
    if (filter !== null) {
      filter = encodeObjectToBase64(filter)
    }
    const { data } = yield call(transactionsApiService.get, '/metrics', {
      params: {
        filter: filter,
        offset: offset,
      },
    })
    yield put(transactionActions.fetchTransactionsMetricsSuccess(data.metrics))
  } catch (e) {
    yield put(transactionActions.fetchTransactionsMetricsError(e))
    handleError(e)
  }
}

export function* fetchEnergyConsumptionChart({ filter, offset }) {
  yield put(transactionActions.fetchEnergyConsumptionChartLoading())
  try {
    if (filter !== null) {
      filter = encodeObjectToBase64(filter)
    }
    const { data } = yield call(transactionsApiService.get, '/chart', {
      params: {
        filter: filter,
        offset: offset,
      },
    })
    yield put(
      transactionActions.fetchEnergyConsumptionChartSuccess(
        data.energyConsumption,
      ),
    )
  } catch (e) {
    yield put(transactionActions.fetchEnergyConsumptionChartError(e))
    handleError(e)
  }
}

export function* fetchAllSubscriptions({ country }) {
  yield put(transactionActions.fetchAllSubscriptionsLoading())
  try {
    const { data } = yield call(
      transactionsApiService.get,
      '/allSubscriptions',
      {
        params: {
          country: country,
        },
      },
    )
    yield put(transactionActions.fetchAllSubscriptionsSuccess(data))
  } catch (e) {
    yield put(transactionActions.fetchAllSubscriptionsError(e))
    handleError(e)
  }
}
